import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var logInRes;
export const logInTodo = createAsyncThunk('logIn', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'login',
            data: {
                "vuser_name": data.username,
                "vpassword": data.password,
                "ibusiness_area_id":'1'
               
            },
            headers: { "Content-Type": "application/json" }
        })
        return logInRes = res.data

    } catch (error) {
        return logInRes = error.response.data
    }
})


